import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export const ProtectedRoute = ({ children, role }) => {
  const { user, loading } = useAuth();

  if (loading || user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="w-8 h-8 animate-spin text-[#FF4D00]" />
      </div>
    );

  if (!user) return <Navigate to="/login" replace />;

  if (role === "admin" && user.role !== "admin") return <Navigate to="/portal" replace />;
  if (role === "creative" && user.role !== "creative" && user.role !== "admin") return <Navigate to="/admin" replace />;

  if (user.role === "creative" && user.status !== "approved") {
    if (user.status === "pending_onboarding") return <Navigate to="/onboarding" replace />;
    return <Navigate to="/pending" replace />;
  }

  return children;
};
